import React from "react";

export const GoogleMapsContext = React.createContext<{ googleLoaded: boolean; loadError?: Error }>({
    googleLoaded: false,
    loadError: undefined
});
